module.exports = __webpack_public_path__ + "static/media/accessory22.64336ddb.webp";